import {
  DoctorActiveListActionTypes,
  DOCTOR_ACTIVE_NOTE_LIST_FAIL,
  DOCTOR_ACTIVE_NOTE_LIST_LOADING,
  DOCTOR_ACTIVE_NOTE_LIST_SUCCESS,
  DoctorActiveNoteListState,
  DOCTOR_ACTIVE_NOTE_LIST_API_MSG,
  DOCTOR_ACTIVE_NOTE_LIST_API_RES,
} from "./ActionTypes";
import { DoctorActiveListResponse } from "./Model";

const initialStateEditPosts: DoctorActiveNoteListState = {
  loading: false,
  doctorActiveNoteListRes: {} as DoctorActiveListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const doctorActiveNoteListReducer = (
  state = initialStateEditPosts,
  action: DoctorActiveListActionTypes
): DoctorActiveNoteListState => {
  switch (action.type) {
    case DOCTOR_ACTIVE_NOTE_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case DOCTOR_ACTIVE_NOTE_LIST_SUCCESS:
      return {
        ...state,
        doctorActiveNoteListRes: action.payload,
        successMsg: action.successMsg,
      };
    case DOCTOR_ACTIVE_NOTE_LIST_FAIL:
      return {
        ...state,
        doctorActiveNoteListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DOCTOR_ACTIVE_NOTE_LIST_API_MSG:
      return {
        ...state,
        doctorActiveNoteListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DOCTOR_ACTIVE_NOTE_LIST_API_RES:
      return {
        ...state,
        doctorActiveNoteListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};